import React, { lazy } from "react";
import { Box } from "@mui/material";
import Navbar from "../widgets/navbar/navbar";
import MenuDrawer from "../../../Components/Widgets/MenuDrawer";
import SubMenuDrawer from "../../../Components/Widgets/SubMenuDrawer";
import Footer from "../widgets/footer";
import RevealSection from "../widgets/common/reveal-section";

const GiftCardsSection = lazy(
  () => import("../../default/widgets/sliders/gift-cards-section"),
);

const RecentlyViewed = lazy(
  () => import("../../../Components/Widgets/RecentlyViewed"),
);

const ExportDefault = (props) => {
  const gap = { xs: 6, md: 8 };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Navbar bg_color="#fff" {...props} />
      <MenuDrawer {...props} />
      <SubMenuDrawer {...props} />

      <RevealSection id="giftCards">
        <GiftCardsSection {...{ ...props, mb: gap, smallSpacing: true }} />
      </RevealSection>

      <RevealSection id="recentlyViewed" variant="products">
        <RecentlyViewed
          {...props}
          mb={gap}
          title="ITEMS YOU VIEWED"
          productDisplay={{
            showName: false,
            showCollection: false,
            showPrice: false,
            showGems: false,
            showCuration: true,
          }}
        />
      </RevealSection>

      <Footer {...props} />
    </Box>
  );
};

export default ExportDefault;
